import { useTranslation } from 'react-i18next';
import { NavigationCard } from './NavigationCard';
import PropTypes from 'prop-types';
import { appNavigate } from '../utils/appNavigation';

const ActionsButtons = () => {
  const { t } = useTranslation();

  return (
    <div className="inset-x-0 bottom-0 z-50">
      {/* <div className="max-w-screen-md mx-auto py-4 space-y-4"> */}
        <div className="grid grid-cols-2 gap-4">
          <NavigationCard
            to="/request"
            title={t('Make a request')}
            description={t('New ticket')}
            isActive={true}
            onClick={() => {
              appNavigate('request');
            }}
          />
          <NavigationCard
            to="/issues"
            title={t('Requests list')}
            description={t('View all tickets')}
            isActive={true}
            onClick={() => {
              appNavigate('issues');
            }}
          />
        </div>
      {/* </div> */}
    </div>
  );
};

ActionsButtons.propTypes = {
  isIssuesRoute: PropTypes.bool.isRequired,
};

export { ActionsButtons };

